module.exports = __webpack_public_path__ + "img/ico-google.d308937c.svg";